import {createSlice} from '@reduxjs/toolkit'

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: {
    name: '',
    email: '',
    userRoles: []
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.name = action.payload.name
      state.email = action.payload.email
      state.userRoles = action.payload.roles
    }
  }
})

export const {setUserInfo} = userProfileSlice.actions

export default userProfileSlice.reducer
